import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "@/components/Login";
import Scanner from "@/components/Scanner";
import History from "@/components/History";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(localStorage.getItem("user"));
  const [operario, setOperario] = useState(localStorage.getItem("operario"));
  const [tipoTrabajo, setTipoTrabajo] = useState(localStorage.getItem("tipoTrabajo") || "molduras");
  const [operarioNombre, setOperarioNombre] = useState(localStorage.getItem("operarioNombre") || "");
  const [estadoDestino, setEstadoDestino] = useState(localStorage.getItem("estadoDestino"));

  const handleLogin = (tokenData, userData, operarioData, tipoTrabajoData, operarioNombreData, estadoDestinoData) => {
    setToken(tokenData);
    setUser(userData);
    setOperario(operarioData);
    setTipoTrabajo(tipoTrabajoData);
    setOperarioNombre(operarioNombreData || "");
    setEstadoDestino(estadoDestinoData ? String(estadoDestinoData) : "");
    localStorage.setItem("token", tokenData);
    localStorage.setItem("user", userData);
    localStorage.setItem("tipoTrabajo", tipoTrabajoData);
    if (operarioNombreData) {
      localStorage.setItem("operarioNombre", operarioNombreData);
    } else {
      localStorage.removeItem("operarioNombre");
    }
    if (estadoDestinoData !== undefined && estadoDestinoData !== null) {
      localStorage.setItem("estadoDestino", String(estadoDestinoData));
    } else {
      localStorage.removeItem("estadoDestino");
    }
    if (operarioData) {
      localStorage.setItem("operario", operarioData);
    }
  };

  const handleLogout = () => {
    // Limpiar estado
    setToken(null);
    setUser(null);
    setOperario(null);
    setTipoTrabajo("molduras");
    setOperarioNombre("");
    setEstadoDestino("");
    
    // Limpiar localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("operario");
    localStorage.removeItem("tipoTrabajo");
    localStorage.removeItem("operarioNombre");
    localStorage.removeItem("estadoDestino");
    
    // Forzar recarga completa y redirigir a login
    // Usar window.location.href para evitar problemas en móvil (igual que el botón de historial)
    window.location.href = '/login';
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              !token ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/"
            element={
              token ? (
                <Scanner
                  token={token}
                  user={user}
                  operario={operario}
                  tipoTrabajo={tipoTrabajo}
                  operarioNombre={operarioNombre}
                  estadoDestino={estadoDestino}
                  onLogout={handleLogout}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/history"
            element={
              token ? (
                <History key="history-page" token={token} tipoTrabajo={tipoTrabajo} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;